import { Component, OnInit, Output, EventEmitter, ElementRef, Input, ComponentFactoryResolver } from "@angular/core";
declare var jQuery: any;
import "../../../../assets/semantic/semantic.min.js";
import { FormBuilder, FormGroup, FormControl, FormArray } from "@angular/forms";


import { PlanningService } from "../../../_services/planning.service";
import { PlanningPalettesService } from "../../../_services/planning-palettes.service";
import { SecurityService } from "../../../_services/security.service";
import { ClientService } from "../../../_services/client.service";
import { ToastService } from "../../../_services/toast.service";


import * as moment from 'moment';


@Component({
  selector: "client-planning-modal",
  templateUrl: "./client-planning-modal.component.html",
  styleUrls: ["./client-planning-modal.component.css"],
})

export class ClientPlanningModalComponent implements OnInit {
  
  @Output() refresh: EventEmitter<boolean> = new EventEmitter<boolean>();
  private planning_id: number;
  private is_admin;
  private planning: object;
  private provider_payment_date_client = null;
  private client_payment_date_client = null;
  private planning_palettes: Array<Object> | null = null;


  private statuses = [
    { name: 'Facture client vérifiée', checked: false },
    { name: 'Facture client réglée', checked: false },
    { name: 'Relance client', checked: false },
    { name: 'Facture fournisseur vérifiée', checked: false },
    { name: 'Facture fournisseur réglée', checked: false },
    { name: 'Relance fournisseur', checked: false },
  ];
  palettes_form: FormGroup;

  planning_form = new FormGroup({
    loading_place: new FormControl({disabled: true}),
    loading_hour: new FormControl({disabled: true}),
    ref_loading: new FormControl({disabled: true}),
    shipping_place: new FormControl({disabled: true}),
    shipping_hour: new FormControl({disabled: true}),
    ref_delivery: new FormControl({disabled: true}),
    ref_client: new FormControl({disabled: true}),
    ref_client_interne: new FormControl(),
    note_client: new FormControl(),
    provider_payment_date_client: new FormControl(),
    client_payment_date_client: new FormControl(),
    state_billing_client: new FormArray([])
  });

  billing_form_arr = this.planning_form.get('state_billing_client') as FormArray;

  constructor(
    private service: ClientService,
    private toast: ToastService,
    private security: SecurityService,
    private planningPalettesService: PlanningPalettesService, 
    private fb: FormBuilder
  ) { }
  
  get itemsFormArray(): FormArray {
    return this.palettes_form.get('palettes') as FormArray;
  }

  // Method to reset the FormArray
  resetItemsFormArray() {
    while (this.itemsFormArray.length !== 0) {
      this.itemsFormArray.removeAt(0);
    }
  }
  
  ngOnInit() {
    this.palettes_form = this.fb.group({
      palettes: this.fb.array([])
    });
    
    
  }
  
  private _patchValues(response) {
    let toPatch = {
      loading_place: response.loading_place,
      loading_hour: response.loading_hour,
      ref_loading:response.ref_loading,
      shipping_place: response.shipping_place,
      shipping_hour:response.shipping_hour,
      ref_delivery: response.ref_delivery,
      provider_payment_date_client: response.provider_payment_date_client,
      client_payment_date_client: response.client_payment_date_client,
      ref_client: response.ref_client,
      ref_client_interne: response.ref_client_interne
    }
    
    this.planning_form.patchValue(toPatch);
    
    //reset cases
    while (this.billing_form_arr.length !== 0) {
      this.billing_form_arr.removeAt(0)
    }
    let billing = '';

    if (response.state_billing_client)
      billing = response.state_billing_client.split(',');
  
    this.statuses.forEach((status, index) => {
      
      let checked = (billing.indexOf(index.toString()) != -1) ? true : false;
      this.billing_form_arr.push(
        new FormGroup(
          {
            name: new FormControl(status.name),
            checked: new FormControl(checked),
          }
        )
      );
    });
  }
  //get planning palettes
  getPlanningPalettes(planning_id) {
    this.planningPalettesService.getPlanningPalettes(planning_id).subscribe(
      (response) => {
        this.planning_palettes = response;
        
        let index = 0;
        for (let palette of response) {
          const item = this.fb.group({
            id: palette.id,
            chargees: palette.chargees,
            rendues: palette.rendues,
            livrees: palette.livrees,
            reprises: palette.reprises,
          });
          this.itemsFormArray.push(item);
          this.planning_palettes[index] = { ...this.planning_palettes[index], total_geofret: (palette.rendues - palette.chargees) };
          this.planning_palettes[index] = { ...this.planning_palettes[index], total_entrepot: (palette.reprises - palette.livrees) };
          index++;
          //this.planning_palettes
          
        }
        
      },
      (error) => {
        //console.log("this.getPlanningPalettes.getPlanningPalettes error:", error);
        this.toast.error(
          error.error && error.error.message 
            ? error.error.message 
            : `Une erreur est survenue lors de la récupération des palettes du planning.`,
           false,
          "Récupération des palettes"
        );
      }
    );
  }
// maj des observations
  updateNote(planning_id, event) {
    var value = event.target.parentElement.parentElement.getElementsByTagName("TEXTAREA")[0].value;
    var params = {};
    params["note_client"] = value;
    this.planning_form.patchValue({ note_cllient: value });
    this.service.updatePlanning(planning_id, params).subscribe((response) => {
      this.closeModal();
    });
  }

  //ouverture modal
  openModal(planning_id: number) {
    this.is_admin = this.security.isAdmin();
    this.planning_id = planning_id;
    
    this.resetItemsFormArray();
    this.getPlanningPalettes(this.planning_id);
    this.getPlanningDetail(this.planning_id);
    
    
    jQuery('#planning_infos').modal('show');
    jQuery('#planning_infos .menu .item').tab();
  }
  
  //close modal and refresh planing
  closeModal() {
    jQuery('#planning_infos').modal('hide');
    //this.refresh.emit(true);
  }
  //recup du contenu planning pour la modal
  getPlanningDetail(planning_id: number) {
    this.service.getPlanningById(planning_id).subscribe((response) => {
      if (response.provider_payment_date_client)
        this.provider_payment_date_client = moment(response.provider_payment_date_client).locale('fr').format('ddd D-MM-y');
      if (response.client_payment_date_client)
        this.client_payment_date_client = moment(response.client_payment_date_client).locale('fr').format('ddd D-MM-y');

      this.planning = response;
      
      this._patchValues(response);

      
    });
    
    
  }
  updatePlanning(planning_id, data)
  {
    let arrChecked = []; 
    if (data.state_billing_client)
    {
      data.state_billing_client.forEach(function (element, index) {
        if (element.checked)
          arrChecked.push(index);
      })
    }
    data.state_billing_client = arrChecked.join(',');

    //format dates de factu
    if (data.provider_payment_date_client) {
      data.provider_payment_date_client = data.provider_payment_date_client.formatted;
    }
    if (data.client_payment_date_client) {
      data.client_payment_date_client = data.client_payment_date_client.formatted;  
    }

    this.service.updatePlanning(planning_id, data).subscribe((response) => {
      this.closeModal();
    });
  }

}


// WEBPACK FOOTER //
// /usr/src/app/src/app/_components/client/client-planning-modal/client-planning-modal.component.ts